var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("radio-button-row", {
        key: _vm.radioButtonValueChanged,
        attrs: {
          title: _vm.isB
            ? "BudgetaryEstimate.Investment.HasPersonnel"
            : "BudgetaryEstimate.PersonnelExpenses.HasPersonnel",
          instructionsKey:
            "BudgetaryEstimate.PersonnelExpenses.HasPersonnel_Instructions",
          required: true
        },
        model: {
          value: _vm.personnelExpenses.hasSalariedPersonnel,
          callback: function($$v) {
            _vm.$set(_vm.personnelExpenses, "hasSalariedPersonnel", $$v)
          },
          expression: "personnelExpenses.hasSalariedPersonnel"
        }
      }),
      _vm._v(" "),
      _vm.showSalaryItems
        ? _c(
            "div",
            [
              _c("salary-table", {
                attrs: {
                  title:
                    "BudgetaryEstimate.PersonnelExpenses.SalaryItems.Title",
                  instructionsKey:
                    "BudgetaryEstimate.PersonnelExpenses.SalaryItems.Title_Instructions",
                  items: _vm.personnelExpenses.salaryItems,
                  createSalaryItem: _vm.addNewRow
                }
              }),
              _vm._v(" "),
              _vm.showDividedSalaryItems
                ? _c("salary-table", {
                    attrs: {
                      title:
                        "BudgetaryEstimate.PersonnelExpenses.DividedSalaryItems.Title",
                      items: _vm.personnelExpenses.dividedSalaryItems,
                      createSalaryItem: _vm.addNewRow,
                      isDivided: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("estimates-and-details-control", {
                attrs: {
                  id: "yearly-personnel-expenses",
                  titleKey:
                    "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Title",
                  tableKey:
                    "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Entry",
                  instructionsKey:
                    "BudgetaryEstimate.PersonnelExpenses.YearlyPersonnelExpenses.Title_Instructions",
                  showColumnTotals: true,
                  showRowTotals: true,
                  required: true
                },
                model: {
                  value: _vm.personnelExpenseWrappers,
                  callback: function($$v) {
                    _vm.personnelExpenseWrappers = $$v
                  },
                  expression: "personnelExpenseWrappers"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }